import React, {useState} from "react";
import {createPortal} from "react-dom";
import {Link} from "react-router-dom";
import {Dropdown} from "react-bootstrap";
import classNames from "classnames";
import BlankUser from '../assets/images/users/blank-user.png'
import styles from "./ProfileDropdown.module.scss";

interface ProfileMenuItem {
    label: string;
    icon: string;
    redirectTo: string;
}

interface ProfileDropdownProps {
    menuItems: Array<ProfileMenuItem>;
    profilePic?: string;
    username: string;
    userTitle?: string;
}

const ProfileDropdown = (props: ProfileDropdownProps) => {
    const profilePic = props["profilePic"] || null;
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

    /*
     * toggle profile-dropdown
     */
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    return (
        <>
        {/* Dim the page content behind the open menu (Figma: Profile Click).
            Portaled to body so it isn't trapped in the topbar stacking context;
            sits below the topbar/menu/bottom-bar but above page content. */}
        {dropdownOpen &&
            createPortal(
                <div className={styles.backdrop} onClick={toggleDropdown} />,
                document.body
            )}
        <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
            <Dropdown.Toggle
                id="dropdown-profile"
                as="a"
                onClick={toggleDropdown}
                className={classNames(
                    "nav-link nav-user me-0 waves-effect waves-light",
                    {show: dropdownOpen}
                )}
            >
                <img src={profilePic ?? BlankUser} className="rounded-circle" alt=""/>
                <span className="pro-user-name ms-1">
          {props["username"]} <i className="mdi mdi-chevron-down"></i>
        </span>
            </Dropdown.Toggle>
            <Dropdown.Menu className={`dropdown-menu dropdown-menu-end ${styles.menu}`}>
                <div className={styles.list} onClick={toggleDropdown}>
                    {(props.menuItems || []).map((item, i) => {
                        const isLast = i === props["menuItems"].length - 1;
                        return (
                            <React.Fragment key={i}>
                                {isLast && <div className={styles.divider} />}
                                <Link
                                    to={item.redirectTo}
                                    className={classNames(styles.item, {
                                        [styles.itemFilled]: !isLast,
                                    })}
                                    key={i + "-profile-menu"}
                                >
                                    <i className={item.icon}></i>
                                    <span>{item.label}</span>
                                </Link>
                            </React.Fragment>
                        );
                    })}
                </div>
            </Dropdown.Menu>
        </Dropdown>
        </>
    );
};

export default ProfileDropdown;
